import { jsx as l } from "react/jsx-runtime";
import "react";
var d = (o) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...o,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 18c0 7.732-6.268 14-14 14S4 25.732 4 18 10.268 4 18 4s14 6.268 14 14ZM18 9.25c.966 0 1.75.784 1.75 1.75v5.25H25a1.75 1.75 0 1 1 0 3.5h-5.25V25a1.75 1.75 0 1 1-3.5 0v-5.25H11a1.75 1.75 0 1 1 0-3.5h5.25V11c0-.966.784-1.75 1.75-1.75Z",
    clipRule: "evenodd"
  })
});
export {
  d as default
};
